import { render, staticRenderFns } from "./ViewLessonDialog.vue?vue&type=template&id=df17b6d4&scoped=true"
import script from "./ViewLessonDialog.vue?vue&type=script&lang=js"
export * from "./ViewLessonDialog.vue?vue&type=script&lang=js"
import style0 from "./ViewLessonDialog.vue?vue&type=style&index=0&id=df17b6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df17b6d4",
  null
  
)

export default component.exports